export default __webpack_public_path__ + "static/media/20_mobile.c97e0ae9.jpg";